import { AfterViewInit, Component, ElementRef, EventEmitter, inject, Input, OnDestroy, Output } from '@angular/core';
import { distinctUntilChanged, fromEvent, map, Subject, takeUntil } from 'rxjs';
import { User } from '@sentry/angular';
import { ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-financial-evaluation',
  templateUrl: './financial-evaluation.component.html',
  styleUrls: ['./financial-evaluation.component.scss'],
  styles: [`
    .my-custom-tabs-container .mat-mdc-tab-body-content {
      overflow-x: hidden !important;
    }
  `],
	encapsulation: ViewEncapsulation.None
})
export class FinancialEvaluationComponent implements AfterViewInit, OnDestroy {
  @Input() application: any;
  @Input() currentUser: User | null = null;
  @Output() applicationChange = new EventEmitter();
	applicationId: string = null;
  isScrolled = false;
  private readonly _onDestroy = new Subject<void>();
  private readonly _elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  constructor(){}

  ngAfterViewInit(): void {
    // Show the header bar shadow only once the summary content has scrolled
    const scrollContainer = this._elementRef.nativeElement.closest('.scrollable-content');
    if (!scrollContainer) {
      return;
    }
    fromEvent(scrollContainer, 'scroll', { passive: true })
      .pipe(
        map(() => scrollContainer.scrollTop > 0),
        distinctUntilChanged(),
        takeUntil(this._onDestroy)
      )
      .subscribe((isScrolled) => (this.isScrolled = isScrolled));
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  onApplicationChanged(application: any) {
		this.applicationId = application.id;
		// this.getApplication(application.id);
	}
}
